// Dependencies
import React, { FunctionComponent, useEffect, useRef } from "react";
import Chart from "chart.js/auto";

// Styles
import { Container } from "./styles";

// Types
type WebpChartItemProps = {
    data: any;
    value: string;
    label: string;
};

export const WebpChartItem: FunctionComponent<WebpChartItemProps> = ({ data, value, label }) => {
    const chartEl = useRef<HTMLCanvasElement>(null);
    const chartInstance = useRef<Chart | null>(null);

    useEffect(() => {
        if (chartEl.current !== null) {
            const ctx = chartEl.current.getContext("2d");

            if (chartInstance.current) {
                chartInstance.current.destroy();
            }

            chartInstance.current = new Chart(ctx ?? "", data);
        }

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
                chartInstance.current = null;
            }
        };
    }, [data]);

    return (
        <Container>
            <div className="wrapper">
                <canvas ref={chartEl} />

                <div className="title-wrapper">
                    <span className="value">{value}</span>

                    <span className="label">{label}</span>
                </div>
            </div>
        </Container>
    );
};
